import { getPropertyValue } from 'framework-listing-lib/utils/crmObject';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { Link } from 'foundations-components/transitional/components/Link';
//@ts-expect-error missing types
import { getCompareRoute } from 'FormsCommonComponents/lib/RouteGenerators';
import { trackDashboardInteraction } from 'FormsUI/utils/TrackingUtils';
import { PROPERTIES } from 'FormsUI/components/dashboard/frameworkTable/constants';
import { GenerateChartIcon } from 'foundations-assets/icons/components/GenerateChartIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CompareBulkActionComparisonAllowed = props => {
  const formIds = props.selectedObjects.map(crmObject => getPropertyValue(crmObject, PROPERTIES.FORM_ID));
  const href = getCompareRoute(formIds);
  const onClick = () => {
    trackDashboardInteraction('selected-bulk-compare');
  };
  const disabled = formIds.length > 10;
  return /*#__PURE__*/_jsx(Tooltip, {
    disabled: !disabled,
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "dashboard.table.tableActions.compareTooltip.title"
    }),
    children: /*#__PURE__*/_jsxs(Link, {
      disabled: disabled,
      onClick: onClick,
      href: href,
      "data-action": "bulk-compare",
      children: [/*#__PURE__*/_jsx(GenerateChartIcon, {}), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "dashboard.table.tableActions.compareForms"
      })]
    })
  });
};
export default CompareBulkActionComparisonAllowed;